import React from 'react';
import ReactDOM from 'react-dom';
import Page from 'Common/Page/';
import CodeBlock from 'Common/CodeBlock';

import Logo from './index';

class App extends React.Component {
  render() {
    return (
      <Page title='Logo'>
        <Logo page='money' />
        <CodeBlock
          value={`import { Logo } from '@politico/interactive-style-elections';

<Logo dems/>
        `}
        />
      </Page>
    );
  }
}

export default App;

ReactDOM.render(<App />, document.getElementById('app'));
